import { createTheme } from '@mui/material/styles';

const spacing = 8;
// All the following keys are optional.
// We try our best to provide a great default value.
export const theme = createTheme({
  palette: {
    primary: {
      main: '#f34b15',
      mainLighter: '#f75c0e',
    },
    secondary: {
      main: '#010c26',
    },
    gray: {
      light: '#676d7d',
      main: '#010c26',
    },
    white: '#FFFFFF',
    black: '#000000',
    red: {
      main: '#FBE9E7',
      dark: '#c62828',
    },
    success: {
      main: '#2e7d32',
      secondary: '#e8f5e9'
    },
    orange: {
      main: '#f75c0e',
    },
    table: {
      header: '#cccccc',
    },
    gradient: {
      dark: '#f34b15',
      lighter: '#f75c0e',
      light: '#ff8000',
    }
  },
  spacing,
  drawerWidth: {
    open: 30 * spacing,
    closed: 7 * spacing,
  },
  gap: spacing * 4,
  breakpoints: {
    values: {
      xs: 0,
      sm: 640,
      md: 1024,
      lg: 1240,
      xl: 1680,
    },
  },
});
